(() => {
  'use strict';
  const node = document.getElementById('neko-member-config');
  if (!node || window.NekoMemberAccess) return;
  const config = JSON.parse(node.textContent);
  if (config.staging && new URLSearchParams(location.search).get('view') === 'member-preview') document.body.classList.add('nm-review');
  const key = 'neko:member-return:v1:' + (config.staging ? config.themeId : 'live');
  const eventsKey = 'neko:member-events:v1:' + config.themeId;
  let locked = !config.loggedIn, checkedAt = 0, checking;
  const safeReturn = raw => {
    try {
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !/^\/(pages\/explore|products\/[^/]+)\/?$/.test(url.pathname)) return null;
      const out = new URL(url.pathname, location.origin);
      ['variant', 'ref'].forEach(k => { if (url.searchParams.has(k)) out.searchParams.set(k, url.searchParams.get(k)); });
      if (config.staging) {
        out.searchParams.set('preview_theme_id', String(config.themeId));
        if (url.searchParams.get('view') === 'member-preview') out.searchParams.set('view', 'member-preview');
      }
      return out.pathname + out.search;
    } catch { return null; }
  };
  const readPending = () => {
    try {
      const p = JSON.parse(sessionStorage.getItem(key));
      return p && Date.now() - p.at < 30 * 60 * 1000 && safeReturn(p.to) ? p : null;
    } catch { return null; }
  };
  const track = (type, surface, variant) => {
    const e = { t: type, s: surface, at: Date.now() };
    if (/^\d{1,20}$/.test(String(variant || ''))) e.v = String(variant);
    if (config.staging) {
      try {
        const events = JSON.parse(sessionStorage.getItem(eventsKey) || '[]');
        sessionStorage.setItem(eventsKey, JSON.stringify(events.concat(e).slice(-200)));
      } catch {}
      return;
    }
    let vid;
    try {
      vid = localStorage.getItem('nekoExploreVid');
      if (!vid) { vid = crypto.randomUUID().replace(/-/g, ''); localStorage.setItem('nekoExploreVid', vid); }
    } catch { return; }
    try { navigator.sendBeacon(config.proxy + '/explore-evt', JSON.stringify({ vid, ev: [e] })); } catch {}
  };
  const decorate = root => {
    const nodes = root.matches?.('[data-member-preview]') ? [root] : root.querySelectorAll('[data-member-preview]');
    nodes.forEach(preview => {
      const surface = preview.dataset.memberSurface;
      preview.querySelectorAll('[data-member-action]').forEach(link => {
        const to = safeReturn(location.href);
        const base = link.dataset.memberAction === 'register' ? config.registerUrl : config.loginUrl;
        const url = new URL(base, location.origin);
        if (to && url.origin === location.origin) {
          url.searchParams.set('return_url', to);
          if (config.staging) url.searchParams.set('preview_theme_id', String(config.themeId));
          link.href = url.href;
        }
      });
      if (!preview.dataset.memberTracked) {
        preview.dataset.memberTracked = '1';
        const observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) {
            track('teaser', surface, new URLSearchParams(location.search).get('variant'));
            observer.disconnect();
          }
        }, { threshold: 0.25 });
        observer.observe(preview);
      }
    });
  };
  const previewHTML = () => (document.getElementById('neko-member-product-preview') || document.getElementById('neko-member-product-fallback'))?.innerHTML || '';
  const deny = () => {
    locked = true;
    config.loggedIn = false;
    const explore = document.querySelector('[data-neko-explore]');
    const template = document.getElementById('neko-member-explore-preview');
    if (explore && template) { explore.replaceWith(template.content.cloneNode(true)); }
    if (config.protectedProduct) {
      document.querySelectorAll('.kuji-slide-container,[data-kuji-container]').forEach(el => { el.innerHTML = previewHTML(); el.removeAttribute('data-member-suspended'); });
    }
    decorate(document);
    document.dispatchEvent(new CustomEvent('neko:member-locked'));
  };
  const ensure = async () => {
    if (locked) return false;
    if (Date.now() - checkedAt < 5000) return true;
    if (checking) return checking;
    checking = (async () => {
      const url = new URL('/', location.origin);
      url.searchParams.set('section_id', 'neko-member-session');
      if (config.staging) url.searchParams.set('preview_theme_id', String(config.themeId));
      const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!res.ok) throw new Error('session_unavailable');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const marker = doc.querySelector('[data-neko-member-session]');
      if (!marker || marker.dataset.themeId !== String(config.themeId)) throw new Error('session_unavailable');
      if (marker.dataset.nekoMemberSession !== 'in') { deny(); return false; }
      checkedAt = Date.now();
      return true;
    })().finally(() => { checking = null; });
    return checking;
  };
  window.NekoMemberAccess = { config, ensure, deny, previewHTML, decorate, track, get locked() { return locked; } };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-member-action]');
    if (!link) return;
    decorate(link.closest('[data-member-preview]'));
    const to = safeReturn(location.href);
    if (!to) return;
    const surface = link.closest('[data-member-preview]').dataset.memberSurface;
    try { sessionStorage.setItem(key, JSON.stringify({ to, at: Date.now(), surface, action: link.dataset.memberAction })); } catch {}
    track(link.dataset.memberAction === 'register' ? 'register_click' : 'login_click', surface, new URLSearchParams(location.search).get('variant'));
  });
  const pending = readPending();
  if (pending && !config.loggedIn && /^\/account/.test(location.pathname)) {
    const applyReturn = () => {
      document.querySelectorAll('form[action*="/account"]').forEach(form => {
        const kind = form.querySelector('[name="form_type"]')?.value;
        if (!['customer_login','create_customer','reset_customer_password'].includes(kind)) return;
        let input = form.querySelector('input[name="return_to"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.appendChild(input); }
        if (input.value !== pending.to) input.value = pending.to;
      });
      document.querySelectorAll('a[href*="/account/login"],a[href*="/account/register"]').forEach(a => {
        const url = new URL(a.href, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('return_url', pending.to);
        if (config.staging) url.searchParams.set('preview_theme_id', String(config.themeId));
        if (a.href !== url.href) a.href = url.href;
      });
    };
    applyReturn();
    new MutationObserver(applyReturn).observe(document.body, { childList: true, subtree: true });
  }
  if (pending && config.loggedIn) {
    track('member_return', pending.surface);
    try { sessionStorage.removeItem(key); } catch {}
    if (/^\/account\/?$/.test(location.pathname)) location.replace(pending.to);
  }
  document.addEventListener('cf:form_submitted', async event => {
    if (!pending || pending.action !== 'register' || config.loggedIn || event.detail?.formId !== 'mMtzpM') return;
    const form = event.target.closest?.('form[data-cf-form="mMtzpM"]');
    if (!form || form.id !== 'create_customer') return;
    for (let i = 0; i < 4; i++) {
      try {
        const url = new URL('/', location.origin);
        url.searchParams.set('section_id', 'neko-member-registration');
        if (config.staging) url.searchParams.set('preview_theme_id', String(config.themeId));
        const res = await fetch(url, { cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(3000) });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const identity = doc.querySelector('[data-neko-member-registration]');
        const submittedEmail = String(event.detail?.submissionData?.email || '').trim().toLowerCase();
        const created = Number(identity?.dataset.created) * 1000;
        if (res.ok && submittedEmail && identity?.dataset.email.trim().toLowerCase() === submittedEmail && created >= pending.at - 60000 && created <= Date.now()) {
          track('registration_confirmed', pending.surface);
          location.assign(pending.to); return;
        }
      } catch {}
      await new Promise(resolve => setTimeout(resolve, 500 * (i + 1)));
    }
  });
  decorate(document);
  const observer = new MutationObserver(records => {
    records.forEach(r => r.addedNodes.forEach(n => { if (n.nodeType === 1) decorate(n); }));
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const targets = () => document.querySelectorAll('[data-neko-explore],.kuji-slide-container,[data-kuji-container]');
  window.addEventListener('pagehide', () => {
    if (config.loggedIn && (config.protectedProduct || document.querySelector('[data-neko-explore]'))) targets().forEach(el => el.setAttribute('data-member-suspended', ''));
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    checkedAt = 0;
    try { if (await ensure()) targets().forEach(el => el.removeAttribute('data-member-suspended')); } catch { deny(); }
  });
  if (config.loggedIn && location.pathname.startsWith('/products/') && new URLSearchParams(location.search).get('ref') === 'explore') {
    track('pdp_arrival', 'product', new URLSearchParams(location.search).get('variant'));
  }
})();
